export const WIN_MESSAGES = ['miywâsin!', 'takahki anima!', 'kikaskihtân!']
